import { render, staticRenderFns } from "./SuppliesUpdate.vue?vue&type=template&id=7ded3a8c&scoped=true&"
import script from "./SuppliesUpdate.vue?vue&type=script&lang=js&"
export * from "./SuppliesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ded3a8c",
  null
  
)

export default component.exports